import { render, staticRenderFns } from "./BigQ.vue?vue&type=template&id=6b4e6efa&scoped=true&"
import script from "@/scripts/QA/Question/components/BigQ?vue&type=script&lang=js&"
export * from "@/scripts/QA/Question/components/BigQ?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4e6efa",
  null
  
)

export default component.exports